import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useHasQueueMetrics } from '@/api/use-branch-features';
import { useQueueLogin } from '@/api/use-queue-login';
import { useExtension } from '@/hooks/use-extension';
import { useMode } from '@/hooks/use-mode';
import { extensionSSEAtom } from '@/store/atoms';
import { openWidget } from '@/utils/open-widget';

export function useLogin() {
  const mode = useMode();
  const hasQueueMetrics = useHasQueueMetrics();
  const sseExtension = useAtomValue(extensionSSEAtom);
  const extension = useExtension();
  const {
    mutate: login,
    reset: resetLoginMutation,
    isSuccess: isLoggedOnQueue,
  } = useQueueLogin();

  const extensionNumber =
    mode === 'desktop'
      ? sseExtension
      : mode === 'webrtc'
        ? extension?.number
        : null;

  useEffect(() => {
    if (hasQueueMetrics !== true || !extensionNumber) {
      return;
    }

    login(extensionNumber);
    return resetLoginMutation;
  }, [hasQueueMetrics, extensionNumber, login, resetLoginMutation]);

  useEffect(() => {
    if (
      (hasQueueMetrics === true && isLoggedOnQueue) ||
      (hasQueueMetrics === false && extensionNumber)
    ) {
      openWidget();
    }
  }, [hasQueueMetrics, isLoggedOnQueue, extensionNumber]);

  return { isLoggedOnQueue };
}
